import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initAnalytics } from '@/lib/analytics';

// Binds the page-hide flush so the last page view of a session isn't lost.
// No-ops unless VITE_ENABLE_ANALYTICS is true.
initAnalytics();

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

createRoot(rootElement).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
